import { render, staticRenderFns } from "./AppVersionForm.vue?vue&type=template&id=20cbb4a4&scoped=true"
import script from "./AppVersionForm.vue?vue&type=script&lang=js"
export * from "./AppVersionForm.vue?vue&type=script&lang=js"
import style0 from "./AppVersionForm.vue?vue&type=style&index=0&id=20cbb4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cbb4a4",
  null
  
)

export default component.exports